/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseUgcBlockFragment, UgcBlockFragment, FullUgcBlockFragment} from '@amblique/contentful/app/contentful/fragments/ugc-block';

/**
 * Get a single UgcBlock by ID (base - scalars only)
 */
export const getBaseUgcBlockById = gql`
  ${BaseUgcBlockFragment}

  query GetBaseUgcBlockById($id: String!, $locale: String!, $preview: Boolean) {
    ugcBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseUgcBlockFragment
    }
  }
`;

/**
 * Get a single UgcBlock by ID (standard - 1 level deep)
 */
export const getUgcBlockById = gql`
  ${UgcBlockFragment}

  query GetUgcBlockById($id: String!, $locale: String!, $preview: Boolean) {
    ugcBlock(id: $id, locale: $locale, preview: $preview) {
      ...UgcBlockFragment
    }
  }
`;

/**
 * Get a single UgcBlock by ID (full - 2 levels deep)
 */
export const getFullUgcBlockById = gql`
  ${FullUgcBlockFragment}

  query GetFullUgcBlockById($id: String!, $locale: String!, $preview: Boolean) {
    ugcBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullUgcBlockFragment
    }
  }
`;

/**
 * Get all UgcBlock entries with pagination (base - scalars only)
 */
export const getBaseUgcBlocks = gql`
  ${BaseUgcBlockFragment}

  query GetBaseUgcBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [UgcBlockOrder]
    $where: UgcBlockFilter
    $preview: Boolean
  ) {
    ugcBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseUgcBlockFragment
      }
    }
  }
`;

/**
 * Get all UgcBlock entries with pagination (standard - 1 level deep)
 */
export const getUgcBlocks = gql`
  ${UgcBlockFragment}

  query GetUgcBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [UgcBlockOrder]
    $where: UgcBlockFilter
    $preview: Boolean
  ) {
    ugcBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...UgcBlockFragment
      }
    }
  }
`;

/**
 * Get all UgcBlock entries with pagination (full - 2 levels deep)
 */
export const getFullUgcBlocks = gql`
  ${FullUgcBlockFragment}

  query GetFullUgcBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [UgcBlockOrder]
    $where: UgcBlockFilter
    $preview: Boolean
  ) {
    ugcBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullUgcBlockFragment
      }
    }
  }
`;
